var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"MainContent",attrs:{"id":"MainLoading"}},[_vm._m(0),_c('div',{staticClass:"background_box",attrs:{"data-dialog-background":""}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog_box",attrs:{"data-dialog-box":""}},[_c('img',{attrs:{"src":"/img/logo_black.svg"}}),_c('p')])
}]

export { render, staticRenderFns }